import { BaseCrudApi } from './abstract/base-crud.api';

export class PaymentsApi extends BaseCrudApi {
  constructor() {
    super('payments')
  }
}
